import React from "react";

export default function PageHeader({ title, description }) {
  return (
    <header className="page-header">
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </header>
  );
}
